import React, { Component } from 'react';
import styled from 'styled-components';
import {
  Box,
  Button,
  Card,
  Flex,
  Heading,
  Text,
} from 'rebass';
import { Formik, Form } from 'formik';
import TextInput from '../components/TextInput';
import { FormField } from '../components/FormField';
import { ADMIN_MAP_LOCALDB_ACCOUNT_TO_ATHENA_ID, ADMIN_REMAP_MOBILEUSER_ASSOCIATED_USER } from '../graphql';
import { compose, withApollo } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications/dist/ToastProvider';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-top: 48px;
`;

class RemapMobileUserAssociatedUser extends Component {
  handleSubmit = async (values, actions) => {
    actions.setSubmitting(true);

    try {
      const res = await this.props.client.mutate({
        mutation: ADMIN_REMAP_MOBILEUSER_ASSOCIATED_USER,
        variables: {
          email: values.email,
        },
      });
      
      if (res && res.data && res.data.remapMobileUserAssociatedUser) {
        if (res.data.remapMobileUserAssociatedUser.ok === true) {
          actions.resetForm();
          this.props.toastManager.add('Reassociation successful', {
            appearance: 'success',
          });
        } else {
          this.props.toastManager.add(
            res.data.remapMobileUserAssociatedUser.customError ||
              'Error updating',
            { appearance: 'error' }
          );
          console.log(
            'Unable to update associated user: ',
            res.data.remapMobileUserAssociatedUser.customError
          );
        }
      } else {
        actions.setSubmitting(false);
        this.props.toastManager.add('Error updating, please try again', {
          appearance: 'error',
        });
      }

      actions.setSubmitting(false);
    } catch (err) {
      console.log('ADMIN_REMAP_MOBILEUSER_ASSOCIATED_USER Err', err);
      actions.setSubmitting(false);
      this.props.toastManager.add('Error updating, please try again', {
        appearance: 'error',
      });
    }
  };
  
  render() {
    return (
      <Container>
        <Flex m={[3, 5]} flex={1} flexDirection="column">
          <Heading mb={4} mt={[3, 0]} ml={[1, 0]} fontSize={[4, 5]}>
            Remap Mobile User associated web user
          </Heading>
          <Text>Will associated the web user to the mobile user. The email address must be identical.</Text>
          <Card mb={4} p={[3, 4]}>
            <Flex flexDirection={'column'} flex={1} alignItems="center">
              <Formik
                initialValues={{ email: '' }}
                onSubmit={(values, actions) =>
                  this.handleSubmit(values, actions)
                }
                render={({
                  errors,
                  touched,
                  isValid,
                  isSubmitting,
                }) => (
                  <Form style={{ width: '300px' }}>
                    <Flex flexDirection="column" flex={1}>
                      <Heading mb={4}>Patient's Email</Heading>
                    </Flex>
                    <FormField mb={4} error={touched.email && errors.email}>
                      <TextInput
                        placeholder="Email Address"
                        type="email"
                        name="email"
                      />
                    </FormField>

                    <Button
                      mt={4}
                      mb={4}
                      variant="primary"
                      width={1 / 2}
                      disabled={!isValid || isSubmitting}
                      type="submit"
                    >
                      Reassociate
                    </Button>
                  </Form>
                )}
              />
            </Flex>
          </Card>
        </Flex>
      </Container>
    );
  }
}

export default compose(
  withApollo,
  withToastManager
)(RemapMobileUserAssociatedUser);
